import React from 'react';

const TermsAndConditions = () => {
    return (
        <div className="terms-container" style={{ padding: '30px', maxWidth: '800px', margin: 'auto' }}>
            <h2 style={{ color: 'var(--color-turquoise-teal)' }}>Terms and Conditions</h2>
            
         <section style={{ marginBottom: '30px' }}>
    <h4 style={{ borderBottom: '2px solid #1FB6A6', paddingBottom: '10px', color: 'var(--color-oxford-blue)' }}>
        For Customers: Data Privacy & Service Commitment
    </h4>
    <ul style={{ lineHeight: '1.8', color: 'var(--color-oxford-blue)', listStyleType: 'none', paddingLeft: '0' }}>
        <li style={{ marginBottom: '15px' }}>
            <strong>🔒 Data Sovereignty:</strong> Docity guarantees that any information not available in the public domain (Private Documents) will never be transferred, sold, or replicated for third-party use. Your private data remains your property.
        </li>
        <li style={{ marginBottom: '15px' }}>
            <strong>📑 Scope of Analysis:</strong> Our professional audit is strictly limited to your property purchase records and government-maintained statutory records. We cross-reference your submissions with official land records to ensure the highest degree of accuracy.
        </li>
        <li style={{ marginBottom: '15px' }}>
            <strong>🎯 Purpose Limitation:</strong> All private documentation uploaded to this platform is used exclusively for the generation of requested property insights and verification reports. Once the service is concluded, your data is archived under strict encryption.
        </li>
        <li style={{ marginBottom: '15px' }}>
            <strong>⚖️ Public Domain Transparency:</strong> Docity may reference and display information already available in the public domain, such as Master Plans, Land Use policies, and Zonal regulations, as part of your comprehensive property report.
        </li>
        <li style={{ marginBottom: '15px' }}>
            <strong>🛡️ Identity Protection:</strong> We employ industry-standard SSL encryption to ensure that your identity and property location are shielded from unauthorized access during the verification process.
        </li>
        <li style={{ marginBottom: '15px' }}>
            <strong>🚫 Disclaimer of Legal Title:</strong> While our Civil Engineers provide expert analysis based on statutory records, the reports provided by Docity serve as a professional opinion and do not replace an official title deed or government-issued ownership certificate.
        </li>
    </ul>
</section>
        </div>
    );
};

export default TermsAndConditions;

